import React, { useRef, useState } from 'react';
import { AUTH_HEADING, BRAND_LOGO_ALT, brandLogo } from '../branding';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function ResetPassword() {
  const emailRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    const email = emailRef.current?.value?.trim() || '';
    if (!email) {
      setSuccessMessage('');
      setErrorMessage('Enter the email address linked to your staff account.');
      return;
    }

    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setSuccessMessage('A password reset link has been sent to your email address.');
    } catch (error) {
      console.error('Failed to send password reset email:', error);

      if (error.code === 'auth/invalid-email') {
        setErrorMessage('Enter a valid email address.');
      } else if (error.code === 'auth/user-not-found') {
        setErrorMessage('No staff account was found with that email address.');
      } else {
        setErrorMessage('We could not send the reset email right now. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex loginContainer">
      <div className="resetleft">
        <div className="authPanel">
          <Link to="/login"><img src={brandLogo} alt={BRAND_LOGO_ALT} className="loginLogo" /></Link>
          <h5>Reset your password</h5>
          <h6>Enter your staff email address and we will send you a link to choose a new password.</h6>

          <Form onSubmit={handleSubmit}>
            <Form.Label className="inputLabel">Email</Form.Label>
            <InputGroup className="mb-3 authInputGroup">
              <InputGroup.Text id="reset-email-addon">
                <FontAwesomeIcon icon={faEnvelope} className="theLoginIcon" />
              </InputGroup.Text>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                className="loginForm"
                ref={emailRef}
                autoComplete="email"
              />
            </InputGroup>

            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            {successMessage && <Alert variant="success">{successMessage}</Alert>}

            {!isSubmitting && (
              <button type="submit" className="signInbtnn">
                Send reset link
              </button>
            )}

            {isSubmitting && (
              <Button variant="primary" disabled className="signInbtProgress mt-3">
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span> Sending...</span>
              </Button>
            )}
          </Form>

          <p className="authPageLinkText">
            <Link to="/login" className="fgPassLink">
              Back to login
            </Link>
          </p>
        </div>
      </div>

      <div className="resetRight">
        <div className="authMediaOverlay authMediaOverlayWarm"></div>
        <div className="loginCont authResetMediaContent">
          <span className="authBadge">Account Recovery</span>
          <h3>{AUTH_HEADING}</h3>
          <p>We will email a secure reset link so you can create a new password and continue working without support delays.</p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
